import { render, staticRenderFns } from "./Pengaturan.vue?vue&type=template&id=e634ee2a"
import script from "./Pengaturan.vue?vue&type=script&lang=js"
export * from "./Pengaturan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports